
export const GET_UPGRADESTATUS = `/upgrade-status`

export const UPGRADESTATUS_QUERY_KEYS = {
	GET_UPGRADESTATUS: 'getUPGRADESTATUS'
}
